(function () {
    'use strict';

    const STEPS = {
        WHY_PLAID: 'why-plaid',
        CONNECT_BANK_ACCOUNT: 'connect-bank-account', // the plaid dialog, not HB
        CHOOSE_BANK_SUB_ACCOUNTS: 'choose-bank-sub-accounts',
        SHOULD_CONNECT_ANOTHER_BANK_ACCOUNT: 'should-connect-another-bank-account',
    };

    Controllers.ConnectBankAccountModalController = class ConnectBankAccountModalController extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor($scope, $injector, $modalInstance, $translate, src, step, isMultiSelect, props, PlaidLinkHelperService,
                    AnalyticsService, PopupMessageService, UsersManager, PendingTasksManager,
                    _, $log) {
            super($scope, $injector);
            this.__objectType = 'ConnectBankAccountModalController';
            this.$log = $log;
            this._ = _;
            this.$modalInstance = $modalInstance;
            this.$translate = $translate;
            this.PlaidLinkHelperService = PlaidLinkHelperService;
            this.AnalyticsService = AnalyticsService;
            this.PopupMessageService = PopupMessageService;
            this.UsersManager = UsersManager;
            this.PendingTasksManager = PendingTasksManager;

            this.imageSrcRoot = 'https://res.cloudinary.com/honeybook/image/upload/v1579424123/app/logos/';

            this.accountTypes = [
                    { name: 'American Express', imageSrc: this.imageSrcRoot + 'amex.png'},
                    { name: 'Bank of America', imageSrc: this.imageSrcRoot + 'boa.png'},
                    { name: 'Charles SCHWAB', imageSrc: this.imageSrcRoot + 'charles-schwab.png'},
                    { name: 'CHASE', imageSrc: this.imageSrcRoot + 'chase.png'},
                    { name: 'WELLS FARGO', imageSrc: this.imageSrcRoot + 'wells-fargo.png'},
                    { name: 'VISA', imageSrc: this.imageSrcRoot + 'visa.png'},
                    { name: 'mastercard', imageSrc: this.imageSrcRoot + 'mastercard.png'}
                ];

            this.src = src;
            this.AnalyticsService.trackLoad(this, 'connect bank account modal', {
                source: this.src});

            this.refundAmount = props.refundAmount;

            this.plaid_products = this.PlaidLinkHelperService.lazyInit(['transactions']);
            this.user = UsersManager.getCurrUser();
            this.allSelectedSubAccounts = [];
            this.currBankSubAccounts = [];
            this.connectStep = step ? STEPS[step] : STEPS.CONNECT_BANK_ACCOUNT;
            this.isLoading = false;
            this.isMultiSelect = isMultiSelect;
            this.inProgress = false;

            if (this.connectStep === STEPS.CONNECT_BANK_ACCOUNT) {
                this.plaidShow();
            }
        }

        handleAddAccountsClick() {
            this.connectStep = STEPS.CONNECT_BANK_ACCOUNT;
            this.plaidShow();
        }

        plaidShow() {
            this.isLoading = true;
            this.PlaidLinkHelperService.openPlaidDialog().then((token) => {
                    this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.add_bank_account);
                    this.UsersManager.connectPlaidBankAccount(this.user, token, this.getCurrPlaidInstId(), this.getCurrPlaidInstName()).then((res) => {
                            this.currBankSubAccounts = res.data;
                            this.isLoading = false;
                            this.connectStep = STEPS.CHOOSE_BANK_SUB_ACCOUNTS;
                        }).catch((res) => {
                            if (res.data && res.data.error) {
                                this.errorMessage = res.data.error_message;
                                this.hasError = true;
                            }
                            this.currBankSubAccounts = [];
                            this.isLoading = false;
                            this.close(this.allSelectedSubAccounts);
                        });
                }).catch((error) => {
                    this.isLoading = false;
                    if(error) {
                        this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.add_bank_account, {}, error);
                    }
                    else {
                        this.AnalyticsService.trackClick(this, 'close plaid dialog');
                        this.close();
                    }
                });
        }

        getCurrPlaidInstName() {
            return this.PlaidLinkHelperService.currInstitutionName;
        }

        getCurrPlaidInstId() {
            return this.PlaidLinkHelperService.currInstitutionId;
        }

        formatBankAccount(bankAccount) {
            return `${bankAccount.name} (${bankAccount.type} / ${bankAccount.subtype})`;
        }

        isSelectionDisabled(bankAccount) {
            if(this.src === 'refund') {
                return bankAccount.type !== 'depository';
            }
            if(!this.isMultiSelect) {
                return !bankAccount.selected && this.allSelectedSubAccounts && this.allSelectedSubAccounts.length > 0;
            } else {
                return bankAccount.is_user_marked_as_business;
            }
        }

        toggleAccountSelection(account) {
            if(this.src === 'refund' && account.available < this.refundAmount) {
                account.selected = false;
                const errorMsg = this.$translate.instant('PAYMENTS.REFUNDS._ACCOUNT_BALANCE_ERROR_');
                this.handleError(errorMsg);
            } else {
                if (account.selected) {
                    this.selectAccount(account);
                } else {
                    this.deselectAccount(account);
                }
            }
        }

        selectAccount(account) {
            this.allSelectedSubAccounts.push(account);
        }

        deselectAccount(account) {
            account.selected = false;
            this.allSelectedSubAccounts.splice(this.allSelectedSubAccounts.findIndex((selectedAccount) => {
                return selectedAccount._id === account._id;
            }), 1);
        }

        handleError(msg) {
            this.AnalyticsService.trackError(this, 'select account', {}, {errorMsg: msg});
            this.PopupMessageService.showConfirmPromise(this.PopupMessageService.severityTypes.error, {
                translationId: msg}, 'PAYMENTS.REFUNDS._CONNECT_TO_DIFFERENT_ACCOUNT_',
                'PAYMENTS.REFUNDS._TRY_LATER_', null, true, false, true)
                .then(() => {
                    this.AnalyticsService.trackClick(this, 'use different account');
                    this.step = 'CONNECT_BANK_ACCOUNT';
                }).catch(() => {
                    this.AnalyticsService.trackClick(this, 'try later');
                    this.close();
                });
        }

        doneSelectingSubAccounts() {
            const selectedBankAccounts = this.currBankSubAccounts.filter((account) => account.selected);

            this.allSelectedSubAccounts = this._.uniq(
                this.allSelectedSubAccounts.concat(selectedBankAccounts), (selectedAccount) => selectedAccount.account_id
            );


            if(this.isMultiSelect) {
                this.selectAccounts(this.allSelectedSubAccounts);
                this.connectStep = STEPS.SHOULD_CONNECT_ANOTHER_BANK_ACCOUNT;
            } else {
                this.close(this.allSelectedSubAccounts[0]);
            }
        }

        selectAccounts(accounts) {
            const accountIds = accounts.map(account => account._id);
            this.UsersManager.selectPlaidBusinessSubAccounts(this.user, accountIds)
                .then((resp) => {
                    this.AnalyticsService.trackSuccess(this, 'successfully selected sub account(s)');
                }).catch((error) => {
                    this.AnalyticsService.trackError(this, 'error fetching selecting sub accounts from plaid', error);
                }).finally(() => {
                    this.inProgress = false;
                });
        }

        connectAnotherAccount() {
            this.connectStep = STEPS.CONNECT_BANK_ACCOUNT;
            this.plaidShow();
        }

        hasAnyBankAccountSelected() {
            return this.allSelectedSubAccounts && this.allSelectedSubAccounts.length > 0;
        }

        close(selectedAccounts) {
            this.$modalInstance.close(selectedAccounts);
        }
    };
}());
